export default __webpack_public_path__ + "static/media/logo.abbde783.png";